import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { ClienteAuthProvider } from "@/lib/clienteAuth";
import AdminLayout from "@/components/AdminLayout";
import ProtectedAdmin from "@/components/ProtectedAdmin";
import InstallPWA from "@/components/InstallPWA";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Clientes from "@/pages/Clientes";
import Orcamentos from "@/pages/Orcamentos";
import OrcamentoEditor from "@/pages/OrcamentoEditor";
import Configuracoes from "@/pages/Configuracoes";
import Portfolio from "@/pages/Portfolio";
import Solicitacoes from "@/pages/Solicitacoes";
import Relatorios from "@/pages/Relatorios";
import PublicOrcamento from "@/pages/PublicOrcamento";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import CadastroCliente from "@/pages/CadastroCliente";
import PortalLogin from "@/pages/PortalLogin";
import PortalCliente from "@/pages/PortalCliente";
import EsqueciSenha from "@/pages/EsqueciSenha";
import RedefinirSenha from "@/pages/RedefinirSenha";
import Pagamento from "@/pages/Pagamento";
import PagamentoSucesso from "@/pages/PagamentoSucesso";
import PagamentoCancelado from "@/pages/PagamentoCancelado";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Synchronous check - runs BEFORE ProtectedRoute
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/q/:token" element={<PublicOrcamento />} />
      <Route path="/pagamento/:token" element={<Pagamento />} />
      <Route path="/pagamento/sucesso" element={<PagamentoSucesso />} />
      <Route path="/pagamento/cancelado" element={<PagamentoCancelado />} />
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro/:codigo" element={<CadastroCliente />} />
      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal/esqueci-senha" element={<EsqueciSenha />} />
      <Route path="/portal/redefinir-senha/:token" element={<RedefinirSenha />} />
      <Route path="/portal" element={<PortalCliente />} />
      <Route element={<ProtectedAdmin />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="orcamentos" element={<Orcamentos />} />
          <Route path="orcamentos/novo" element={<OrcamentoEditor />} />
          <Route path="orcamentos/:id" element={<OrcamentoEditor />} />
          <Route path="solicitacoes" element={<Solicitacoes />} />
          <Route path="relatorios" element={<Relatorios />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="configuracoes" element={<Configuracoes />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ClienteAuthProvider>
            <Toaster position="top-right" richColors />
            <AppRouter />
            <InstallPWA />
          </ClienteAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
